export const GET_GALLERY_IMAGES = 'GET_GALLERY_IMAGES'
export const GET_GALLERY_IMAGES_SUCCESS = 'GET_GALLERY_IMAGES_SUCCESS'
export const GET_GALLERY_IMAGES_FAILURE = 'GET_GALLERY_IMAGES_FAILURE'
